import api from '../utils/api';

/**
 * Authentication Service
 * All authentication related API calls
 */

export const authService = {
  /**
   * Login user
   */
  login: async (email, password) => {
    return api.post('/auth/login', { email, password });
  },

  /**
   * Logout user
   */
  logout: async () => {
    return api.post('/auth/logout');
  },

  /**
   * Get current user profile
   */
  getProfile: async () => {
    return api.get('/auth/me');
  },

  /**
   * Google login with ID token
   */
  googleLogin: async (idToken) => {
    return api.post('/auth/google/login', { idToken });
  },

  /**
   * Change password
   */
  changePassword: async (currentPassword, newPassword) => {
    return api.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
  },

  /**
   * Forgot password
   */
  forgotPassword: async (email) => {
    return api.post('/auth/forgot-password', { email });
  },

  /**
   * Reset password
   */
  resetPassword: async (token, newPassword) => {
    return api.post('/auth/reset-password', { token, newPassword });
  },

  /**
   * Verify email
   */
  verifyEmail: async (token) => {
    return api.post('/auth/verify-email', { token });
  },

  /**
   * Resend verification email
   */
  resendVerification: async (email) => {
    return api.post('/auth/resend-verification', { email });
  },
};
